import { BasePrescriptionTemplate } from './BasePrescriptionTemplate';
import type { PrescriptionPrintTemplateProps } from '../types';

const extractGynecologyFindings = (specialtyData: Record<string, unknown> | null): string | null => {
  if (!specialtyData) return null;

  const findings = specialtyData.hallazgos_ginecologicos;
  if (typeof findings !== 'string') return null;

  const trimmedFindings = findings.trim();
  if (!trimmedFindings) return null;

  return `Hallazgos ginecológicos: ${trimmedFindings}`;
};

export function GynecologyPrescriptionTemplate(props: PrescriptionPrintTemplateProps) {
  const gynecologySummary = extractGynecologyFindings(props.specialtyData);

  if (!gynecologySummary) {
    return <BasePrescriptionTemplate {...props} />;
  }

  const mergedRecommendations = props.consultation.general_recommendations
    ? `${gynecologySummary}\n${props.consultation.general_recommendations}`
    : gynecologySummary;

  return (
    <BasePrescriptionTemplate
      {...props}
      consultation={{
        ...props.consultation,
        general_recommendations: mergedRecommendations,
      }}
    />
  );
}
